import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const App = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const accessToken = localStorage.getItem("accessToken");

        if (!accessToken) {
            navigate("/login"); // Redirect to login if token does not exist
            return;
        }

        try {
            const decoded = jwtDecode(accessToken); // Decode token
            const userRole = decoded.role; // Assuming the role is stored in the token
            
            if (userRole === "superadmin" || userRole === "admin") {
                navigate("/admin");
            } else if (userRole === "employee") {
                navigate("/user");
            } else {
                navigate("/unauthorized"); // Fallback for unknown roles
            }
        } catch (error) {
            console.error("Invalid token, redirecting to login.");
            localStorage.removeItem("accessToken");
            navigate("/login");
        }
    }, [navigate]);

    return null; // No UI needed, just handling redirects
};

export default App;